module.exports = __webpack_public_path__ + "img/email.54c6cf13.svg";